<template>
  <div @click="handleClick">
    <slot />

    <portal>
      <bindMobile
        v-if="!isLogin"
        v-model="isShowLoginModel"
        v-bind="finalBindMobileComponentsProps"
        @success="loginSuccess"
      />
    </portal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import bindMobile from 'app/web/component/consult/bindMobile.vue'
import login from 'app/web/component/consult/hd/login.js'
import portal from 'app/web/component/consult/portal.vue'
export default {
  mixins: [login],
  props: {
    bindMobileProps: {
      type: Object,
      default() {
        return {}
      }
    },
    isLoginPlatform: {
      type: Boolean,
      default() {
        return this.isWebviewMp && !this.isNativeLoginWebviewMp
      }
    }
  },
  data() {
    return {
      isShowLoginModel: false
    }
  },
  components: {
    bindMobile,
    portal
  },
  computed: {
    ...mapGetters({
      isLogin: 'isLogin'
    }),
    finalBindMobileComponentsProps() {
      const defaultProps = {
        submitText: '确认',
        title: '登录',
        style: { zIndex: 12, position: 'relative' }
        // login: this.loginStatus
      }

      return {
        ...defaultProps,
        ...this.bindMobileProps
      }
    }
  },
  methods: {
    async loginSuccess() {
      if (this.isWebviewMp) {
        this.$uniApp.postMessage({
          type: 'refresh'
        })
      }
      await this.$store.dispatch('getUserInfo', true)
      this.handleClick()
    },
    async handleClick() {
      await this.$store.dispatch('getUserInfo')
      if (!this.isLogin) {
        const { isLoginPlatform } = this

        if (isLoginPlatform) {
          this.isShowLoginModel = true
        } else {
          this.toLogin()
        }
        return
      }
      this.$emit('loginedClick')
    }
  }
}
</script>

<style lang="scss">
.consult-expert-list-to-order-btn {
  position: fixed;
  right: 0;
  bottom: 120px;
  margin-bottom: constant(safe-area-inset-bottom);
  background-image: linear-gradient(90deg, #3ab0ff, #54c8ff);
  border-radius: 40px 0 0 40px;
  width: 180px;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  color: #ffffff;
  z-index: 2;

  .icon-node-website {
    font-size: 27px;
    margin-right: 5px;
  }
}
</style>
